<template>
	<div class="module_page page_content institution" aria-label="Institution Entities view content page">

		<div class="row page-heading">
      		<div class="col-8 input module_heading" role="heading" aria-level="1">
        		<span class="module_icon ic-inst"></span>
        		<label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        		<!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        		<label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      		</div>

      		<div class="col-4 btn_container">
      		</div>
    	</div>

		<div class="page_content_container inst_entity">

			<institution-menu :uuid="uuid" :active="'otherEntities'"></institution-menu>

			<div class="row pg_content">
		    	<div class="col-12">

				<div class="row tp_row">

					<div class="col-xl-9 col-lg-8 col-md-12 col-sm-12 tp_lft_sec">

			          <b-row class="dashboard-row">
			            <b-col class="col-xl-6 col-lg-12 col-md-12 col-sm-12 lft_col">
			                <div class="card ace_sec" aria-label="Course Catalog, Course Section and Competency Tree Section">
			                    <div class="card-body">

			                        <div class="card-content">

			                        	<div class="row">
			                          		<div @click="catalogsClicked" class="col-xl-6 col-lg-12 col-md-12 col-sm-12 inst_entt_box catalog">
																			<div class="inst_entt_bx_inner">
				                            		<div class="thumbnail">
				                            			<span class="ico-catalog icon"></span>
				                            		</div>
				                            		<div class="title-row">
				                          				<span tabindex="0" class="title">Course Catalogs</span>
				                            		</div>
				                          		</div>
																		</div>

			                          		<div @click="coursesClicked" class="col-xl-6 col-lg-12 col-md-12 col-sm-12 inst_entt_box course">
																			<div class="inst_entt_bx_inner">
																				<div class="thumbnail">
				                              			<span class="icon-course icon"></span>
				                            		</div>
				                            		<div class="title-row">
				                              			<span tabindex="0" class="title">Course Sections</span>
				                            		</div>
				                          		</div>
																		</div>
			                          	</div>

			                          	<div class="row card_btm_row">
			                          		<div @click="competencyTreeClicked" class="col-12 inst_entt_box competency_tree">
																			<div class="inst_entt_bx_inner">
																				<div class="thumbnail">
				                              			<span class="icon-ic_ToC icon"></span>
				                            		</div>
				                            		<div class="title-row">
				                              			<span tabindex="0" class="title">Competency Tree</span>
				                            		</div>
				                          		</div>
																		</div>
			                          	</div>

			                        </div> <!-- card-content end -->
			                    </div> <!-- card-body end -->
			                </div> <!-- card end -->
			            </b-col>

			            <b-col class="col-xl-6 col-lg-12 col-md-12 col-sm-12 rgt_col">
			                <div class="card ace_sec" aria-label="Stream, Channel and Program Guide Section">
			                    <div class="card-body">
			                      <div class="card-content">

															<div class="row">
			                        	<div @click="streamsClicked" class="col-xl-6 col-lg-12 col-md-12 col-sm-12 inst_entt_box stream">
																	<div class="inst_entt_bx_inner">
																		<div class="thumbnail">
			                            		<span class="icon-stream icon"></span>
			                          		</div>
			                          		<div class="title-row">
			                            		<span tabindex="0" class="title">Streams</span>
			                          		</div>
																	</div>
			                        	</div>

			                        	<div @click="channelsClicked" class="col-xl-6 col-lg-12 col-md-12 col-sm-12 inst_entt_box channel">
			                          	<div class="inst_entt_bx_inner">
																		<div class="thumbnail">
			                            		<span class="icon-channel icon"></span>
			                          		</div>
			                          		<div class="title-row">
			                            		<span tabindex="0" class="title">Channels</span>
			                          		</div>
			                        		</div>
																</div>
			                        </div>

			                        <div class="row card_btm_row">
			                        	<div @click="programGuidesClicked" class="col-12 inst_entt_box program_guides">
			                          		<div class="inst_entt_bx_inner">
																			<div class="thumbnail">
			                            			<span class="icon icon-list ic_program_guides"></span>
			                          			</div>
			                          			<div class="title-row">
			                            			<span tabindex="0" class="title">Program Guides</span>
			                          			</div>
																		</div>
			                        	</div>
			                        </div>

			                      </div> <!-- card-content end -->
			                    </div> <!-- card-body end -->
			                </div> <!-- card end -->
			            </b-col>
			          </b-row> <!-- dashboard-row end -->

					</div>


					<div class="col-xl-3 col-lg-4 col-md-12 col-sm-12 tp_rgt_sec">

				        <b-row class="dashboard-row">
				            <b-col cols="12">
				                <div class="card ace_sec" aria-label="Major Minors, Careers and Employer Section">
				                    <div class="card-body">
				                        <div class="card-content">

				                        <div @click="majorMinorsClicked" class="inst_entt_box">
																	<div class="inst_entt_bx_inner bx_v2">
					                          <div class="thumbnail">
					                            <span class="icon icon-list ic_major_minor"></span>
					                          </div>
					                          <div class="title-row">
					                            <span tabindex="0" class="title">
					                              Major Minors
					                            </span>
					                          </div>
																	</div>
				                        </div>

				                        <div @click="careersClicked" class="inst_entt_box card_btm_row">
																	<div class="inst_entt_bx_inner bx_v2">
					                          <div class="thumbnail">
					                            <span class="fas fa-address-book icon ic_career"></span>
					                          </div>
					                          <div class="title-row">
					                            <span tabindex="0" class="title">
					                              Careers
					                            </span>
					                          </div>
					                        </div>
																</div>

				                        <div :disabled="!employerExists" v-bind:class="{'disabled' : !employerExists}" @click="employersClicked" class="inst_entt_box card_btm_row">
																	<div class="inst_entt_bx_inner bx_v2">
					                          <div class="thumbnail">
					                            <span class="ico-employer icon"></span>
					                          </div>
					                          <div class="title-row">
					                            <span tabindex="0" class="title">
					                              Employer
					                            </span>
					                          </div>
					                        </div>
																</div>

				                        </div> <!-- card-content end -->
				                    </div> <!-- card-body end -->
				                </div> <!-- card end -->
				            </b-col>
				        </b-row> <!-- dashboard-row end -->

				    </div> <!-- .tp_rgt_sec end -->


				</div> <!-- .tp_row -->


				<div class="row dashboard-row btm_row">
	                <div class="col-12">
		                <div class="card ace_sec">
		                    <div class="card-body">
								<div class="card-content">
									<div class="row">

										<div @click="jobsClicked" class="col-xl-2 col-lg-4 col-md-6 col-sm-12 inst_entt_box">
											<div class="inst_entt_bx_inner">
												<div class="thumbnail">
													<span class="icon-job icon"></span>
												</div>
												<div class="title-row">
													<span tabindex="0" class="title">Jobs</span>
												</div>
											</div>
										</div>

										<div @click="eventsClicked" class="col-xl-2 col-lg-4 col-md-6 col-sm-12 inst_entt_box">
											<div class="inst_entt_bx_inner">
												<div class="thumbnail">
													<span class="icon fas fa-calendar-alt ic_event"></span>
												</div>
												<div class="title-row">
													<span tabindex="0" class="title">Events</span>
												</div>
											</div>
										</div>

										<div @click="clubsClicked" class="col-xl-2 col-lg-4 col-md-6 col-sm-12 inst_entt_box">
											<div class="inst_entt_bx_inner">
												<div class="thumbnail">
													<span class="ico-club icon"></span>
												</div>
												<div class="title-row">
													<span tabindex="0" class="title">Clubs</span>
												</div>
											</div>
										</div>

										<div @click="peopleClicked" class="col-xl-2 col-lg-4 col-md-6 col-sm-12 inst_entt_box">
											<div class="inst_entt_bx_inner">
												<div class="thumbnail">
													<span class="icon-mentor icon"></span>
												</div>
												<div class="title-row">
													<span tabindex="0" class="title">People</span>
												</div>
											</div>
										</div>

										<div @click="toolsClicked" class="col-xl-2 col-lg-4 col-md-6 col-sm-12 inst_entt_box">
											<div class="inst_entt_bx_inner">
												<div class="thumbnail">
													<span class="fa fa-toolbox icon"></span>
												</div>
												<div class="title-row">
													<span tabindex="0" class="title">Tools</span>
												</div>
											</div>
										</div>

										<div @click="quickLinksClicked" class="col-xl-2 col-lg-4 col-md-6 col-sm-12 inst_entt_box">
											<div class="inst_entt_bx_inner">
												<div class="thumbnail">
													<span class="fa icon-link icon"></span>
												</div>
												<div class="title-row">
													<span tabindex="0" class="title">Quick Links</span>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
						</div> <!-- card-body end -->
					</div> <!-- card end -->

				</div> <!-- dashboard-row .btm_row -->


	        </div>
			</div>


	    </div>  <!-- page_content_container end -->

	</div> <!-- page_content end -->
</template>

<script>
import '../../../assets/module/css/institution/institutionEntities.min.css'
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'

export default {
  name: 'institutionEntities',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole')
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'constructSearchQuery',
      'updateSelectedIndexes'
    ]),

    loadInstitution () {
      this.loadLogDashboardActivity({action: 'viewInstitutionEntitiesView', page: 'institutionEntitiesView', link: '', entityUuid: this.uuid})
      this.loadInstitutionDetail(this.uuid)
    },

    coursesClicked () {
      return this.$router.push({ name: 'courseList' })
    },

    competencyTreeClicked () {
      return this.$router.push({ name: 'competencyTreeList' })
    },

    channelsClicked () {
      return this.$router.push({ name: 'listChannels' })
    },

    programGuidesClicked () {
      return this.$router.push({ name: 'programGuideList' })
    },

    majorMinorsClicked () {
      return this.$router.push({ name: 'majorMinorList' })
    },

    careersClicked () {
      return this.$router.push({ name: 'careerList' })
    },

    employersClicked () {
      if (!this.employerExists) {
        return
      }
      let employerId = this.employer.uuid
      return this.$router.push({name: 'employerHome', params: {uuid: employerId}})
    },

    toolsClicked () {
      return this.$router.push({ name: 'toolList' })
    },

    quickLinksClicked () {
      return this.$router.push({ name: 'quickLinkList' })
    },

    catalogsClicked () {
      return this.$router.push({ name: 'catalogList' })
    },

    streamsClicked () {
      this.searchOnDiscover('Stream')
    },

    jobsClicked () {
      this.searchOnDiscover('Job')
    },

    eventsClicked () {
      this.searchOnDiscover('Event')
    },

    clubsClicked () {
      this.searchOnDiscover('Club')
    },

    peopleClicked () {
      this.searchOnDiscover('Person')
    },

    searchOnDiscover (entityName) {
      this.$router.push({name: 'results', query: {_: new Date().getTime()}})
      this.updateSelectedIndexes([entityName])
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'employer': state => state.employer.employer
    }),

    employerExists () {
      let employer = this.employer
      return employer && employer.uuid
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionEntities.vue